import { Link } from "react-router-dom";
import { toast } from "sonner";
import { ExternalLink, Copy, Globe } from "lucide-react";
import { PortalLoginBox } from "@/components/PortalLogin";

const PORTAL_LOGIN = "https://services.gst.gov.in/services/login";
const STEPS = [
  ["GSTR-2B (Excel)", "Returns Dashboard → GSTR-2B → Download Excel", "reconcile", "GSTR-2B Reconcile"],
  ["E-way bills", "E-way bill portal → Reports → download", "eway", "E-way Bills"],
  ["Cash / credit ledger, challans", "Services → Ledgers / Payments", "ledgers", "Ledgers"],
  ["Sales and purchase registers", "As per your GST Sales Importer / Purchase Master templates", "import", "Import Data"],
];

export function PortalDirectCard({ gstin, clientId, role }) {
  const copy = () => { navigator.clipboard.writeText(gstin); toast.success("GSTIN copied"); };
  return (
    <div className="rounded-lg border border-border bg-card p-5 space-y-4" data-testid="portal-direct-card">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2"><Globe className="h-5 w-5 text-indigo-500" /><span className="font-head font-semibold">GST Portal — direct login</span></div>
        <span className="text-xs font-mono px-2 py-0.5 rounded-md border bg-emerald-500/10 text-emerald-600 border-emerald-500/30">Live</span>
      </div>
      <p className="text-sm text-muted-foreground">Sign in on the official GST portal with the client's User ID, password and captcha. The saved login is encrypted; Admin and Partner can view the password, and every view is recorded in the Audit Log.</p>
      <PortalLoginBox clientId={clientId} role={role} />
      <div className="flex flex-wrap items-center gap-2">
        <a href={PORTAL_LOGIN} target="_blank" rel="noopener noreferrer" data-testid="portal-open-button"
          className="flex items-center gap-2 rounded-md bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 text-sm font-medium">
          <ExternalLink className="h-4 w-4" /> Open GST Portal login
        </a>
        <button onClick={copy} data-testid="portal-copy-gstin-button" className="flex items-center gap-1.5 rounded-md border border-border px-3 py-2 text-xs font-mono hover:bg-muted">
          <Copy className="h-3.5 w-3.5" /> {gstin}
        </button>
      </div>
      <div>
        <div className="small-label mb-2">After downloading from the portal, upload here</div>
        <div className="divide-y divide-border rounded-md border border-border text-xs">
          {STEPS.map(([what, where, tab, label]) => (
            <div key={tab} className="flex flex-wrap items-center justify-between gap-2 px-3 py-2">
              <div><div className="font-medium">{what}</div><div className="text-muted-foreground">{where}</div></div>
              <Link to={`?tab=${tab}`} data-testid={`portal-step-${tab}`} className="text-indigo-600 hover:underline whitespace-nowrap">Upload in {label} →</Link>
            </div>
          ))}
        </div>
      </div>
      <p className="text-xs text-muted-foreground">Prepared GSTR-1 / GSTR-3B / annual returns: download the Excel/JSON from the Returns or Annual tab, upload it on the portal's offline utility, then file with DSC or EVC on the portal.</p>
    </div>
  );
}
